import {JsonProperty} from '@hyperloris/tyson';

export class ApiValidation<T> {
  @JsonProperty()
  item: T | undefined;

  @JsonProperty()
  message: string | undefined;

  @JsonProperty()
  success: boolean = false;
}

